import {
  colorSchemeDark,
  colorSchemeLight,
  themeQuartz,
} from "ag-grid-community"

const sharedParams = {
  fontFamily: "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif",
  spacing: 8,
  rowHeight: 40,
  headerHeight: 44,
  fontSize: 13,
  headerFontSize: 11,
  headerFontWeight: 600,
  wrapperBorderRadius: 0,
  borderRadius: 8,
  wrapperBorder: false,
  cellHorizontalPaddingScale: 1.15,
  iconSize: 14,
} as const

export const agDarkTheme = themeQuartz
  .withPart(colorSchemeDark)
  .withParams({
    ...sharedParams,
    fontSize: 13,
    headerFontSize: 11,
    headerFontWeight: 500,
    rowHeight: 40,
    headerHeight: 36,
    accentColor: "#5B7FFF",
    backgroundColor: "#141824",
    foregroundColor: "#f1f5f9",
    headerBackgroundColor: "rgba(255, 255, 255, 0.03)",
    headerTextColor: "#64748b",
    borderColor: "rgba(255, 255, 255, 0.08)",
    oddRowBackgroundColor: "#141824",
    rowHoverColor: "rgba(255, 255, 255, 0.04)",
    selectedRowBackgroundColor: "rgba(91, 127, 255, 0.12)",
    chromeBackgroundColor: "#141824",
    menuBackgroundColor: "#1e293b",
    popupShadow: "0 4px 24px rgba(0, 0, 0, 0.35)",
    inputBorder: { color: "rgba(255, 255, 255, 0.12)" },
    checkboxCheckedBackgroundColor: "#5B7FFF",
    checkboxCheckedBorderColor: "#5B7FFF",
  })

export const agLightTheme = themeQuartz
  .withPart(colorSchemeLight)
  .withParams({
    ...sharedParams,
    fontSize: 13,
    headerFontSize: 11,
    headerFontWeight: 500,
    rowHeight: 40,
    headerHeight: 36,
    accentColor: "#3b82f6",
    backgroundColor: "#ffffff",
    foregroundColor: "#475569",
    headerBackgroundColor: "#fafbfc",
    headerTextColor: "#94a3b8",
    borderColor: "#eef2f6",
    oddRowBackgroundColor: "#ffffff",
    rowHoverColor: "#f8fafc",
    selectedRowBackgroundColor: "rgba(59, 130, 246, 0.1)",
    chromeBackgroundColor: "#ffffff",
    menuBackgroundColor: "#ffffff",
    popupShadow: "0 2px 16px rgba(0, 0, 0, 0.08)",
    inputBorder: { color: "#e2e8f0" },
    checkboxCheckedBackgroundColor: "#3b82f6",
    checkboxCheckedBorderColor: "#3b82f6",
  })
